import { render, staticRenderFns } from "./PostingPeriodView.vue?vue&type=template&id=76a5c6c3&"
import script from "./PostingPeriodView.vue?vue&type=script&lang=js&"
export * from "./PostingPeriodView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports